const News = () => import('./pages/News.vue');

export default [
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: 'Novidades',
    },
  },
];
